/*
 * Pagination
 *
 * @param {Int} maxRows Limit records in one page
 * @param {String} Url Api endpoint
 * @param {Function} onChangePage Handle onchange page
 * @param {String} keyword Search value
 * @param {Boolean} needExtraData Need to send extra data to parent component
 *
 * @return {Element}
 */
<template>
  <div class="row m-t-sm" v-if="hasNext">
    <div class="flexbox justify-center">
      <a class="text--underline" @click.prevent="loadMore">
        もっと見る
      </a>
    </div>
  </div>
</template>

<script>
import PaginationService from '@/services/paginationservice'
import Util from '@/common/utility'
export default {
  data () {
    return {
      data: [],
      allData: [],
      productData: [],
      newData: [],
      originalData: [],
      productOriginalData: [],
      extraData: null,
      currentPage: 0,
      hasNext: false,
      loader: null,
      needClear: false,
      isLoadMore: false,
      keepSort: false,
      isDestroy: false
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    maxRows: {
      type: Number,
      default: 50
    },
    keyword: {
      type: [String, Object],
      default: ''
    },
    isShowHasFbaLongterm: {
      type: Boolean,
      default: false
    },
    needExtraData: {
      type: Boolean,
      default: false
    },
    loadingTableMode: {
      type: Boolean,
      default: false
    },
    clientMode: {
      type: Boolean,
      default: false
    },
    extraUrl: {
      type: Array
    },
    extraUrlMode: {
      type: Boolean,
      default: false
    },
    needLoading: {
      type: Boolean,
      default: true
    },
    method: {
      type: String,
      default: 'get'
    }
  },
  computed: {
    isPremiumPlan () {
      return this.$store.getters.getUser.memberPlan === '1' && !this.$store.getters.getUser.isPremiumTrial
    }
  },
  created () {
    const showLoading = this.needLoading && !this.clientMode
    this.fetchData(true, showLoading, false)
  },
  methods: {
    /*
     * Fetch data from API
     *
     * @param {Boolean} needClear Need clear all old data in table
     *
     * @return void
     */
    fetchData (needClear = false, showLoading = false, needAll = false, forceClient = false, isSearch = false) {
      this.currentPage = this.currentPage + 1
      if (showLoading) {
        this.loader = this.$loading.show({
          container: this.clientMode && this.$parent.$refs.table ? this.$parent.$refs.table : null
        })
      }
      this.needClear = needClear
      if ((!this.clientMode || this.currentPage === 1) && !needAll && !forceClient) {
        this.fetchDataByAPI(needAll, needClear)
      } else {
        this.fetchDataClientMode(false, true, null, isSearch)
        this.loader && this.loader.hide()
        this.$events.fire('done', this.url)
      }
    },
    /*
     * Handle onclick load more button
     *
     * @return void
     */
    loadMore () {
      if (!this.loader || !this.loader.active) {
        this.isLoadMore = true
        if (this.loadingTableMode) {
          this.fetchData(false, this.loadingTableMode)
        } else {
          this.loader = this.$loading.show()
          this.fetchData(false)
        }
      }
    },
    /*
     * Reload table
     *
     * @return void
     */
    reload (showLoading = false, needAll = false, forceClient = false) {
      this.currentPage = 0
      this.fetchData(true, showLoading, needAll, forceClient)
    },

    /*
     * Fetch data by calling API
     *
     * @param {Boolean} needAll Need to get all data without paginate on server-side
     *
     * @return void
     */
    fetchDataByAPI (needAll, needClear) {
      if (this.isDestroy) return
      let url = this.url
      let payload = null
      if (this.method === 'get') {
        payload = (this.clientMode || needAll) ? {} : {
          limit: this.maxRows,
          page: this.currentPage,
          ...this.keyword
        }
      } else {
        payload = {
          ...this.keyword
        }
        url = `${url}?page=${this.currentPage}&limit=${this.maxRows}`
      }
      const apiMethod = (this.method !== 'get') ? PaginationService.postDataByExtraUrl : PaginationService.getData
      apiMethod(url, payload)
        .then((response) => {
          this.allData = needClear ? [
            ...response.data
          ] : [
            ...this.allData,
            ...response.data
          ]
          this.originalData = needClear ? JSON.parse(JSON.stringify(response.data)) : JSON.parse(JSON.stringify([
            ...this.originalData,
            ...response.data
          ]))
          // this.data = [...response.data]
          if (this.clientMode) {
            this.fetchDataClientMode()
          } else {
            this.newData = [...response.data]
            this.data = needClear ? [
              ...response.data
            ] : [
              ...this.data,
              ...response.data
            ]
            // this.data = [...response.data]
            this.hasNext = this.currentPage < response.totalPage
          }
          if (this.needExtraData) {
            this.extraData = {
              coefficient: response.coefficient
            }
          }
          if (this.extraUrlMode) {
            const asinList = this.clientMode ? response.data.slice(0, this.maxRows).map(item => item.asin) : response.data.map(item => item.asin)
            this.fetchDataByExtraUrl(this.extraUrl, asinList)
          }

          this.$events.fire('done', true)
        })
        .catch((err) => {
          this.currentPage -= 1
          this.$emit('zIndex', 1040)
          this.$events.fire('handleError', err)
          this.$events.fire('done', false)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },

    /*
     * Fetch data in client side
     *
     * @param {Boolean} showFromStart Data start from page 1
     * @param {Boolean} rowChanged All data had changed number of recrords
     *
     * @return void
     */
    fetchDataClientMode (showFromStart = false, rowChanged = true, type = '', isSearch = false) {
      // const startPage = showFromStart ? 0 : this.currentPage - 1
      const startPage = 0
      const currentPage = this.currentPage > 0 ? this.currentPage : 1
      if ((this.keyword && this.keyword.length > 0) || this.isShowHasFbaLongterm) {
        this.data = [...this.allData].filter((item) => {
          if (this.isShowHasFbaLongterm && this.isPremiumPlan && (isNaN(item.agentReturnQuantity) || item.agentReturnQuantity === 0)) return false

          return (
            (item.skus && Object.values(item.skus).map(value => String(value).toLowerCase()).includes(this.keyword.toLowerCase())) ||
            (item.fnskus && Object.values(item.fnskus).map(value => String(value).toLowerCase()).includes(this.keyword.toLowerCase())) ||
            (item.itemId && item.itemId.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.sku && item.sku.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.fnsku && item.fnsku.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.goodsLabel && item.goodsLabel.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.asin && item.asin.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.ean && item.ean.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.productName && item.productName.toLowerCase().includes(this.keyword.toLowerCase())) ||
            (item.itemName && item.itemName.toLowerCase().includes(this.keyword.toLowerCase()))
          )
        })
        if (rowChanged) {
          this.hasNext = currentPage < (this.data.length / this.maxRows)
        }
        this.data = this.data.slice(startPage * this.maxRows, currentPage * this.maxRows)
        if (this.isLoadMore || type === 'delete' || isSearch) {
          this.newData = this.data.slice((currentPage - 1) * this.maxRows, currentPage * this.maxRows)
        }
      } else {
        this.data = [...this.allData].slice(startPage * this.maxRows, currentPage * this.maxRows)
        if (rowChanged) {
          this.hasNext = currentPage < (this.allData.length / this.maxRows)
        }
        if (this.isLoadMore || type === 'delete' || isSearch) {
          this.newData = this.allData.slice((currentPage - 1) * this.maxRows, currentPage * this.maxRows)
        }
      }

      if (this.isLoadMore || type === 'delete' || isSearch) {
        const asinList = this.newData.map(item => item.asin)
        this.fetchDataByExtraUrl(this.extraUrl, asinList, isSearch)
      }
    },

    /*
     * Change data by parent component
     *
     * @param {Object} item Item need to be changed
     * @param {String} type Type of change
     * @param {Boolean} isCallApi Need to call API
     *
     * @return void
     */
    handleData (item, type, isCallApi, isAmazon = false, isShipping = false) {
      this.keepSort = !isCallApi
      this.needClear = true
      let rowChanged = true
      if (type === 'delete') {
        if (isAmazon) {
          this.allData = this.allData.filter(data => data.sku !== item.sku)
          this.originalData = this.originalData.filter(data => data.sku !== item.sku)
        } else if (isShipping) {
          this.allData = this.allData.filter(data => data.itemId !== item.itemId)
          this.originalData = this.originalData.filter(data => data.itemId !== item.itemId)
        } else {
          this.allData = this.allData.filter(data => data.asin !== item.asin)
          this.originalData = this.originalData.filter(data => data.asin !== item.asin)
        }
      } else if (type === 'deleteAll') {
        if (isAmazon) {
          this.allData = this.allData.filter(data => !item.includes(data.sku))
          this.originalData = this.originalData.filter(data => !item.includes(data.sku))
        } else if (isShipping) {
          this.allData = this.allData.filter(data => !item.includes(data.itemId))
          this.originalData = this.originalData.filter(data => !item.includes(data.itemId))
        } else {
          this.allData = this.allData.filter(data => !item.includes(data.asin))
          this.originalData = this.originalData.filter(data => !item.includes(data.asin))
        }
      }
      if (!isCallApi) {
        this.fetchDataClientMode(true, rowChanged, type)
      } else {
        this.fetchNextItem()
      }
    },

    fetchDataByExtraUrl (urlList, asin, isSearch = false) {
      if (urlList.length > 0) {
        urlList.forEach(async (url) => {
          const {chunkData, delayTime} = this.checkInvalidData(url, asin)
          if (chunkData.length > 0 && !this.isDestroy) {
            for (const item of chunkData) {
              const payload = {
                // record: asin
                record: item
              }
              PaginationService.postDataByExtraUrl(url, payload)
                .then((response) => {
                  this.needClear = true
                  let objectResponse = {}
                  response.data.forEach((responseItem) => {
                    objectResponse[responseItem.asin] = responseItem
                  })
                  this.allData = this.allData.map((item) => {
                    let newItem = objectResponse[item.asin]
                    if (url === 'Product/get-identifiers' && newItem !== undefined) {
                      newItem = {
                        ean: newItem.identifiers.length ? newItem.identifiers[0].identifier : ''
                      }
                    }
                    if (newItem) {
                      return {
                        ...item,
                        ...newItem
                      }
                    }
                    return item
                  })
                  const asinList = this.allData.map((item) => item.asin)
                  const waitData = response.data.filter((item) => !asinList.includes(item.asin))
                  if (waitData.length > 0) {
                    this.$events.fire('waitData', waitData, url)
                  }
                  this.fetchDataClientMode(true, false)
                })
                .catch((err) => {
                  this.$emit('zIndex', 1040)
                  this.$events.fire('handleError', err)
                })
                .finally(() => {
                  this.loader && this.loader.hide()
                })
              await Util.delay(delayTime)
            }
          }
        })
      }
    },

    checkInvalidData (extraUrl, asin) {
      let keys = []
      let maxDataPerRequest = 50
      let delayTime = 500
      switch (extraUrl) {
        case 'Product/get-price':
          keys = ['amazonPrice']
          maxDataPerRequest = 20
          delayTime = 100
          break
        case 'Product/get-image-name':
          keys = ['image']
          maxDataPerRequest = 20
          delayTime = 1000
          break
        case 'Product/get-stock-info':
          keys = ['numberOfStock']
          maxDataPerRequest = 50
          delayTime = 500
          break
        case 'Product/get-identifiers':
          keys = ['ean']
          maxDataPerRequest = 20
          delayTime = 1000
          break
        default:
          break
      }
      const matchData = this.allData.filter(item => {
        let match = false
        keys.forEach(key => {
          if (!Object.prototype.hasOwnProperty.call(item, key) || (key === 'ean' && !item.ean)) {
            match = true
          }
        })
        return asin.includes(item.asin) && match
      }).map(item => item.asin)
      const chunkData = Util.chunkArray(matchData, maxDataPerRequest)
      return {
        chunkData,
        delayTime
      }
    }
  },

  watch: {
    data () {
      let newData = null
      if (this.isLoadMore) {
        newData = this.newData
        this.isLoadMore = false
      }
      this.$emit('onChangePage', this.data, this.extraData, this.needClear, this.keepSort, newData)
      if (this.needClear) {
        this.needClear = false
      }
      if (this.keepSort) {
        this.keepSort = false
      }
    },
    keyword (newVal) {
      this.currentPage = 0
      const isClientSide = newVal !== null && this.clientMode
      const isSearch = (newVal !== null && newVal !== '')
      this.fetchData(true, true, isClientSide, isClientSide, isSearch)
    },
    isShowHasFbaLongterm () {
      this.currentPage = 0
      this.fetchData(true, true, true, true, true)
    },
    allData (newVal) {
      if (this.url === 'Product' || this.url === 'PromotionResult/list') {
        this.$events.fire('productData', newVal)
      }
    },
    originalData (newVal) {
      this.$emit('originalData', newVal)
    },
    productData (newVal) {
      if (this.url === 'Product/available' || this.url === 'Product/available_no_refresh' || this.url === 'PromotionProduct/available') {
        this.allData = this.allData.map((item) => {
          const newItem = newVal.find(resItem => resItem.asin === item.asin)
          if (newItem) {
            return {
              ...item,
              ...newItem
            }
          }
          return item
        })
      }
      this.fetchDataClientMode(true)
    }
  },
  beforeDestroy () {
    this.isDestroy = true
    this.loader && this.loader.hide()
    this.$store.commit('toggleModal')
    this.$events.remove('productData')
    this.$events.remove('productOriginalData')
    this.$events.remove('waitData')
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouseAcross/components/Pagination.vue